import React, { useEffect } from 'react';
import { Outlet, PathParam, useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import Routes from 'config/routes';
import { Module_Enum } from 'generated/graphql';

import Page from './page';

interface Props {
  header?: React.ReactNode;
  children?: React.ReactNode;
  img?: { src: string; alt: string };
  footer?: React.ReactNode;
}

// This page is required to switch the currentContructionSite if the user open
// an aggregated report from the url
function ReportAggregatedConnectedPage(props: Props) {
  const {
    isConnected,
    currentConstructionSiteId,
    setCurrentConstructionSiteId,
  } = useAppContext();
  const { t } = useTranslation();
  const { constructionSiteId: paramConstructionSiteId } =
    useParams<PathParam<Routes.ReportAggregated>>();
  invariant(
    paramConstructionSiteId,
    "constructionSiteId isn't set within the route",
  );

  const navTitle = t('module.header', { context: Module_Enum.ShiftReport });

  useEffect(() => {
    if (
      paramConstructionSiteId &&
      paramConstructionSiteId !== currentConstructionSiteId
    ) {
      setCurrentConstructionSiteId(paramConstructionSiteId);
    }
  });

  return (
    <Page
      {...props}
      isConnected={isConnected}
      title={navTitle}
      constructionSiteChangeEnabled={false}
    >
      <Outlet />
    </Page>
  );
}

export default ReportAggregatedConnectedPage;
